import { existsSync } from "fs";
import { exec } from "child_process";
import { promisify } from "util";
import path from "path";
promisify(exec);
function getWorkspaceDir() {
  if (existsSync("/workspace")) {
    return "/workspace";
  }
  if (process.env.MORPHBOX_USER_WORKSPACE) {
    return process.env.MORPHBOX_USER_WORKSPACE;
  }
  try {
    const { stdout } = require("child_process").execSync("git rev-parse --show-toplevel", {
      encoding: "utf8",
      cwd: process.cwd()
    });
    return stdout.trim();
  } catch (error) {
    const currentDir = process.cwd();
    if (path.basename(currentDir) === "web") {
      return path.dirname(currentDir);
    }
    return currentDir;
  }
}
const WORKSPACE_DIR = getWorkspaceDir();
export {
  WORKSPACE_DIR as W
};
